import styled, { css, useTheme } from "styled-components";
import Text from "common/Typography/Text";
import { CSSProperties, useContext } from "react";
import UserAvatar from "common/Avatars/UserAvatar.tsx";
import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface InvitingUserSummaryProps {
  style?: CSSProperties;
  hideBg?: boolean;
}

const InvitingUserSummary = ({ style, hideBg }: InvitingUserSummaryProps) => {
  const theme = useTheme();
  const { isWhitelabel, inviteData } = useContext(
    ExternalConnectAccountContext
  )!;
  const { t } = useTypedTranslation(LanguageNameSpaces.AUTH);
  const image = theme.isDarkMode
    ? inviteData?.inviter_dark_mode_image
    : inviteData?.inviter_light_mode_image;

  return (
    <Wrapper style={style} $hideBg={hideBg}>
      {!hideBg && (
        <Text>
          {t("external_connect.inviting_user", {
            brandPrefix: isWhitelabel ? "" : "Cornix ",
          })}
        </Text>
      )}
      <SummaryWrapper>
        {inviteData && (
          <UserAvatar
            user={{
              image,
              full_name: inviteData.inviter_name,
            }}
            avatarSize={40}
            fallbackInitialsSize={2}
          />
        )}
        {inviteData?.inviter_name && <Text>{inviteData.inviter_name}</Text>}
      </SummaryWrapper>
    </Wrapper>
  );
};

export default InvitingUserSummary;

const Wrapper = styled.div<{ $hideBg?: boolean }>`
  ${(p) =>
    !p.$hideBg &&
    `
  background-color: ${p.theme.colors.lightBlue};
  padding: 12px 16px;
  border-radius: 8px;
    `};
  ${(p) =>
    p.theme.isNewLook &&
    !p.$hideBg &&
    css`
      padding: 16px;
      border: ${p.theme.borders.panel};
      box-shadow: ${p.theme.shadows.panel};
      border-radius: ${p.theme.radii.card}px;
      background-color: ${p.theme.colors.cardLightBgColor};
      color: ${p.theme.colors.secondaryText};
      font-size: 13px;
    `}
`;
const SummaryWrapper = styled.div`
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid ${(p) => p.theme.colors.midBlue};
  border-radius: 12px;
  display: flex;
  align-items: center;
  column-gap: 12px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      margin-top: 10px;
      padding: 8px 12px;
      border-color: ${p.theme.colors.cardBorderColor};
      border-radius: ${p.theme.radii.control + 2}px;
      background: ${p.theme.colors.cardBgColor};
      font-weight: 500;
    `}
`;
